import { clsx } from "clsx";
import type { ReactNode } from "react";

type StatProps = {
  label: ReactNode;
  value: ReactNode;
  hint?: ReactNode;
  className?: string;
  tone?: "default" | "good" | "warn" | "bad";
};

const TONE_VALUE: Record<NonNullable<StatProps["tone"]>, string> = {
  default: "text-foreground-primary",
  good: "text-success",
  warn: "text-warning",
  bad: "text-danger",
};

export function Stat({ label, value, hint, className, tone = "default" }: StatProps) {
  return (
    <div className={clsx("space-y-1", className)}>
      <div className="text-2xs uppercase tracking-wider text-foreground-muted">{label}</div>
      <div className={clsx("text-2xl font-semibold tabular-nums", TONE_VALUE[tone])}>
        {value}
      </div>
      {hint && <div className="text-xs text-foreground-secondary">{hint}</div>}
    </div>
  );
}
